<template>
<div class="spot">
  <div class="text watch"
  :class="{
    'activate': trackTime >= 14.0,
    'fade': trackTime >= 14.75
  }"
  >Watch</div>
  <div class="small-tv"
  :class="{
    'activate': trackTime >= 14.75,
    'move': trackTime >= 15
  }"
  ></div>
  <div class="text K"
  :class="{
    'activate': trackTime >= 15.25,
    'move': trackTime >= 15.75
  }"
  >K</div>
  <div class="text W"
  :class="{
    'activate': trackTime >= 15.85,
    'move': trackTime >= 16.25
  }"
  >W</div>
  <div class="text E"
  :class="{
    'activate': trackTime >= 16.35,
    'move': trackTime >= 16.75
  }"
  >E</div>
  <div class="text T"
  :class="{
    'activate': trackTime >= 16.85,
     'move': trackTime >= 17.25
  }"
  >T</div>
  <div class="text V"
  :class="{
    'activate': trackTime >= 17.35,
     'move': trackTime >= 18
  }"
  >V</div>
  <div class="TV-text"
  :class="{
    'activate': trackTime >= 18.25,
    'move': trackTime >= 19
  }"
  >KWETV</div>
  <p class="here"
  :class="{
    'activate': trackTime >= 19,
    'move': trackTime >= 19.5
  }"
  >We are here for you!</p>
</div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "spot",

   computed: {
    ...mapState([
      "trackTime"
    ])
  },
}
</script>


<style lang="scss">


.activate {
 .spot {
   position: absolute;
   top: 6vw;
   right: 15vw;
   bottom: 10vw;
   left: 15vw;
 }

 .text {
    color: #fff;
    position: absolute;
    font-family: 'Fontdiner Swanky', cursive;
  }

  .here {
    color: #fff;
    text-align: center;
    position: absolute;
    top: 70%;
    left: -40px;
    right: 0;
    display: none;

     &.activate {
      display: block;
     }
  }

  .watch {
    top: 9vw;
    left: 27%;
    font-size: fluid(40px);
    opacity: 0;
    
    &.activate {
      opacity: 1;
      transform: scale(1);
      top: 9vw;
      transition: all ease-in-out .5s;
     }
    &.fade {
      opacity: 0;
      top: -1vw;
      transform: scale(.25);
      transition: all ease-in-out .5s;
    }
  }
  .K {
    top: 12vw;
    left: 45%; 
    transform: scale(4);
    display: none;
  
    &.activate {
      display: block;
     }
    &.move {
      top: 4.5vw;
      left: 31%;
      transform: scale(1.1);
      transition: all ease-in-out .25s;
    }
  }
  .W {
    top: 12vw;
    left: 45%; 
    transform: scale(4);
    display: none;
     &.activate {
      display: block;
     }
  
    &.move {
      top: 4.5vw;
      left: 38%;
      transform: scale(1.2);
      transition: all ease-in-out .25s;
     }
  }
  .E {
    top: 12vw;
    left: 45%; 
    transform: scale(4);
    display: none;

    &.activate {
      display: block;
    }
    &.move {
      top: 4.5vw;
      left: 46%;
      transform: scale(1.2);
      transition: all ease-in-out .25s;
     }
  }
  .T {
    top: 12vw;
    left: 45%; 
    transform: scale(4);
    display: none;

    &.activate {
      display: block;
    }
  
    &.move {
      top: 4.5vw;
      left: 52%;
      transform: scale(1.2);
      transition: all ease-in-out .25s;
     }
  }
  .V {
    top: 12vw;
    left: 45%; 
    transform: scale(4);
    display: none;

    &.activate {
      display: block;
    }
  
    &.move {
      display: block;
      top: 4.5vw;
      left: 58%;
      transform: scale(1.2);
       transition: all ease-in-out .25s;
     }
  }

  .TV-text {
    position: absolute;
    top: 1vw;
    left: 6%;
    width: 80%;
    height: 80%;
    text-indent: -9999px;
    background-image: url("~@/assets/img/producer-small-tv-text.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    display: none;

     &.activate {
     display: block;
     }
  }

 .small-tv {
    position: absolute;
    top: 0vw;
    left: 30%;
    width: 35%;
    height: 35%;
    background-image: url("~@/assets/img/producer-small-tv.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    opacity: 0;
    transform: scale(.25);
    
    &.move {
      opacity: 1;
      transform: scale(.5);
      top: 0vw;
      left: 2vw;
    }
  }
}


</style>